interface ClientModalActionPanelProps {
    typeOfAction: 'newClient' | 'update'
    isLoadingUpdateAPI: boolean;
    isUpdateData: boolean;
    handleCancelUpdate: () => void;
    handleStartUpdate: () => void;
    handleUpdateFinal: () => void;
    labelOne: string;
    labelTwo: string;
    labelThree: string;
    labelFour: string;
    isCustomize?: boolean;
}

export default function ClientModalActionPanel({ isCustomize = false, typeOfAction, isUpdateData, isLoadingUpdateAPI, handleCancelUpdate, handleStartUpdate, handleUpdateFinal, labelOne, labelTwo, labelThree, labelFour }: ClientModalActionPanelProps) {

    if (typeOfAction !== 'update') return null;

    return (
        <div className={`grid ${isLoadingUpdateAPI ? 'grid-cols-1' : 'grid-cols-2'} gap-2`}>
            {/* { isLoadingUpdateAPI ? (
                <button
                    type="button"
                    disabled
                    className="w-full text-sm px-4 py-2 rounded font-medium bg-gray-400 text-white cursor-not-allowed"
                >
                    {labelOne}
                </button>
            ) : (
                <>
                    { isUpdateData ? (
                        <>
                            <button
                                type="button"
                                onClick={handleCancelUpdate}
                                className="w-full text-sm px-4 py-2 rounded font-medium bg-gray-300 text-black"
                            >
                                {labelTwo}
                            </button>
                            <button
                                type="button"
                                onClick={handleUpdateFinal}
                                className="w-full text-sm px-4 py-2 rounded font-medium bg-cbColor text-white"
                            >
                                {labelThree}
                            </button>
                        </>
                    ) : (
                        <button
                            type="button"
                            onClick={handleStartUpdate}
                            className="w-full col-span-2 text-sm px-4 py-2 rounded font-medium bg-cbColor text-white"
                        >
                            {labelFour}
                        </button>
                    )}
                </>
            )} */}
            {isCustomize && (
                isLoadingUpdateAPI ? (
                    <button
                        type="button"
                        disabled
                        className="w-full text-sm px-4 py-2 rounded font-medium bg-gray-400 text-white cursor-not-allowed"
                    >
                        {labelOne}
                    </button>
                ) : (
                    <>
                        {isCustomize ? (
                            <>
                                <button
                                    type="button"
                                    onClick={handleCancelUpdate}
                                    className="w-full text-sm px-4 py-2 rounded font-medium bg-gray-300 text-black"
                                >
                                    {labelTwo}
                                </button>

                                <button
                                    type="button"
                                    onClick={handleUpdateFinal}
                                    className="w-full text-sm px-4 py-2 rounded font-medium bg-cbColor text-white"
                                >
                                    {labelThree}
                                </button>
                            </>
                        ) : (
                            <button
                                type="button"
                                onClick={handleStartUpdate}
                                className="w-full col-span-2 text-sm px-4 py-2 rounded font-medium bg-cbColor text-white"
                            >
                                {labelFour}
                            </button>
                        )}
                    </>
                )
            )}

            {!isCustomize && (
                isLoadingUpdateAPI ? (
                    <button
                        type="button"
                        disabled
                        className="w-full text-sm px-4 py-2 rounded font-medium bg-gray-400 text-white cursor-not-allowed"
                    >
                        {labelOne}
                    </button>
                ) : (
                    <>
                        { isUpdateData ? (
                            <>
                                <button
                                    type="button"
                                    onClick={handleCancelUpdate}
                                    className="w-full text-sm px-4 py-2 rounded font-medium bg-gray-300 text-black"
                                >
                                    {labelTwo}
                                </button>

                                <button
                                    type="button"
                                    onClick={handleUpdateFinal}
                                    className="w-full text-sm px-4 py-2 rounded font-medium bg-cbColor text-white"
                                >
                                    {labelThree}
                                </button>
                            </>
                        ) : (
                            <button
                                type="button"
                                onClick={handleStartUpdate}
                                className="w-full col-span-2 text-sm px-4 py-2 rounded font-medium bg-cbColor text-white"
                            >
                                {labelFour}
                            </button>
                        )}
                    </>
                )
            )}
        </div>
    )
}
